/**
 * Sets the auth cookie as a session cookie (see `src/app/api/dlz-session/route.ts`) – the
 * „Zapamätať si ma“ checkbox left unchecked. The remembered choice keeps using the core `setAuthToken`.
 */
export async function setSessionAuthToken(authToken: string) {
  const response = await fetch('/api/dlz-session', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ authToken }),
  });

  if (!response.ok) throw new Error(`Session cookie request failed (${response.status})`);
}
